'use client';

import './globals.css';
import { ErrorScreen } from '@/components/global/error-screen';

export default function GlobalError({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  return (
    // `global-error` replaces the root layout, so it must render its own document
    // and import the global stylesheet itself.
    <html lang="fr">
      <body className="flex min-h-screen antialiased">
        <ErrorScreen error={error} retry={retry} />
      </body>
    </html>
  );
}
